import { useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { profilerApi } from '@/api/profiler';
import type { CDDReport } from '@/types/profiler';

export function useCDDCase(caseId: string | undefined) {
  const location = useLocation();
  // Navigation state provides instant render; placeholderData (unlike initialData)
  // always fires a background refetch so the full enriched doc from GET /case/{id}/cdd
  // replaces the flat POST /cdd response before the user sees stale zeros.
  const stateReport = (location.state as { report?: CDDReport } | null)?.report;

  return useQuery<CDDReport>({
    queryKey: ['profiler-case-cdd', caseId],
    queryFn: () => profilerApi.getCase(caseId!),
    placeholderData: stateReport,
    enabled: !!caseId && caseId !== 'undefined',
    staleTime: 30_000,
  });
}
